module.exports = __webpack_public_path__ + "img/NT.c85a6c4c.png";